import { GipEvidenceExportConfigForm } from '@app/modules/audit/screens/global-reports/gip/gip-report/view/components/export-modal/GipEvidenceExportConfigForm';
import { auditReports } from '@mi-front/api-clients';
import { Box, Grid } from '@mui/material';
import React from 'react';
import { SelectElement } from 'react-hook-form-mui';
import { FormattedMessage } from 'react-intl';
import { useWizardWithData } from '../../../../../../../../../core/hooks/WizardWithData';
import {
  aodGipExportMessages,
  packageStorageStrategyMessageByValue,
} from '../aod-gip-export-messages';
import { GipAodRuleWizardValues } from '../types';

const packageStorageStrategyOptions = Object.values(
  auditReports.GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnum,
).map((value: auditReports.GipAodRuleEvidenceExportOptionsDtoPackageStorageStrategyEnumKey) => ({
  id: value,
  label: <FormattedMessage key={value} {...packageStorageStrategyMessageByValue[value]} />,
}));

export const AodGipExportOptionsForm: React.FC = () => {
  const wizard = useWizardWithData<GipAodRuleWizardValues>();

  return (
    <GipEvidenceExportConfigForm
      reportType={wizard.data.basic.reportType}
      initialConfig={wizard.data.exportOptions ?? undefined}
      onSubmit={async (data) => {
        wizard.setData({
          exportOptions: data as auditReports.GipAodRuleEvidenceExportOptionsDto,
        });
      }}
    >
      <Box mt={2}>
        <Grid container spacing={2}>
          <Grid item xl={3} lg={4} md={6}>
            <SelectElement
              name="packageStorageStrategy"
              label={<FormattedMessage {...aodGipExportMessages.packageStorageStrategyLabel} />}
              options={packageStorageStrategyOptions}
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>
    </GipEvidenceExportConfigForm>
  );
};
